<template>
  <div>
    <app-bar ref="refAppBar" :users="users" @updated="updated"></app-bar>
    <v-card elevation="0">
      <v-card-title>
        <v-container fluid>
          <v-row align="center">
            <v-col cols="12" sm="3">
              <v-select
                :items="agencies"
                v-model="condition.agency_id"
                label="代理店選択"
                @change="onChangeAgency"
                hide-details
                dense
              ></v-select>
            </v-col>
            <v-col cols="12" sm="3">
              <v-select
                :items="filteredUsers"
                v-model="condition.user_id"
                label="ユーザー名選択"
                @change="onChangeUser"
                hide-details
                dense
              ></v-select>
            </v-col>
            <v-col cols="12" sm="3">
              <v-select
                :items="valid_contract_status"
                v-model="condition.valid_contract"
                label="ステータス"
                @change="changeCondition"
                hide-details
                dense
              ></v-select>
            </v-col>
            <v-col cols="12" sm="3">
              <v-switch v-model="resist_order" label="登録順"></v-switch>
            </v-col>
          </v-row>
          <v-row align="center">
            <v-spacer></v-spacer>
            <v-col cols="12" sm="3">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="（キーワード検索）"
                single-line
                hide-details
                clearable
                dense
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>
      </v-card-title>
      <!-- テーブル -->
      <v-data-table
        :headers="headers"
        :items="desserts"
        :search="search"
        item-key="id"
        :mobile-breakpoint="0"
        :items-per-page="-1"
        :footer-props="{
          'items-per-page-options': [100, 200, 400, -1],
          'items-per-page-text': '表示件数',
        }"
      >
        <!-- eslint-disable-next-line -->
        <template v-slot:footer.page-text="props">
          {{ props.pageStart }} ～{{ props.pageStop }}件／全{{
            props.itemsLength
          }}件
        </template>
        <!-- eslint-disable-next-line -->
        <template v-slot:item.edit="{ item }">
          <v-icon class="pa-1" @click="editItem(item)"> mdi-pencil </v-icon>
        </template>
        <!-- eslint-disable-next-line -->
        <template v-slot:item.agency_name="{ item }">
          <span v-if="item.agency_name">
            {{ item.agency_name
            }}<span v-if="item.agency_contact_name">
              {{ item.agency_contact_name }}</span
            >
          </span>
        </template>
        <!-- eslint-disable-next-line -->
        <template v-slot:item.contract="{ item }">
          <v-icon class="pa-1" @click="contractItem(item)">
            mdi-file-sign
          </v-icon>
        </template>
        <!-- eslint-disable-next-line -->
        <template v-slot:item.shop_site="{ item }">
          <v-icon class="pa-1" @click="shopSiteItem(item)"> mdi-web </v-icon>
        </template>
        <!-- eslint-disable-next-line -->
        <template v-slot:item.valid_contract="{ item }">
          <div class="pa-1">
            <v-chip
              v-if="item.valid_contract"
              class="ma-2"
              color="primary"
              label
              small
            >
              契約中
            </v-chip>
            <v-chip v-else class="ma-2" label small> 契約なし </v-chip>
          </div>
        </template>
        <!-- eslint-disable-next-line -->
        <template v-slot:item.delete="{ item }">
          <v-icon class="pa-1" @click="deleteItem(item)"> mdi-delete </v-icon>
        </template>
        <template v-slot:no-data> 表示するデータがありません </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import {
  ref,
  reactive,
  toRefs,
  defineComponent,
  watch,
  computed,
} from "@vue/composition-api";
import { repositoryFactory } from "@/repository/repositoryFactory";
import store from "@/store/index.js";
import setting from "@/common/setting.js";
import appBar from "./appBar.vue";
import router from "@/router/index";

export default defineComponent({
  components: {
    appBar,
  },
  setup(_, ctx) {
    const usersRepository = repositoryFactory.get("users");
    const shopsRepository = repositoryFactory.get("shops");
    const agenciesRepository = repositoryFactory.get("agencies");
    const refAppBar = ref();
    const state = reactive({
      users: [],
      agencies: [],
      search: "",
      headers: [
        {
          text: "編集",
          value: "edit",
          sortable: false,
          align: "center",
          width: 60,
        },
        {
          text: "代理店",
          value: "agency_name",
          sortable: true,
          class: "td_agency",
        },
        {
          text: "登録ユーザー名",
          value: "user_name",
          sortable: true,
          class: "td_name",
        },
        {
          text: "店舗名",
          value: "name",
          sortable: true,
          class: "td_loginid",
        },
        {
          text: "媒体情報",
          value: "shop_site",
          sortable: false,
          align: "center",
          width: 60,
        },
        {
          text: "契約情報",
          value: "contract",
          sortable: false,
          align: "center",
          width: 60,
        },
        {
          text: "ステータス",
          value: "valid_contract",
          sortable: false,
          align: "center",
        },
        {
          text: "削除",
          value: "delete",
          sortable: false,
          align: "center",
          width: 60,
        },
      ],
      desserts: [], // DataTablesレコード格納用
      condition: {
        user_id: null,
        valid_contract: null,
        agency_id: null,
      },
      resist_order: true, // 登録順
    });

    const valid_contract_status = [
      { value: null, text: "未選択" },
      { value: true, text: "契約中" },
      { value: false, text: "契約なし" },
    ];

    const editItem = (item) => {
      // ダイアログ開く
      console.log("item", item);
      refAppBar.value.action({
        action: "edit",
        value: item.id,
      });
    };

    // データ削除
    const deleteItem = async (item) => {
      if (window.confirm("削除してよろしいですか？")) {
        store.dispatch("loadingIcon/showIcon"); // ローディング表示

        // 有効な契約が残っていないかチェック(未来の分も含めて)

        // 削除処理
        await shopsRepository
          .admin_delete(item.id)
          .then((response) => {
            if (response.data) {
              // データ削除OK
              alert(`「${item.name}」が削除されました。`);
            }
          })
          .catch((error) => {
            throw (
              "ERROR:admin/shop/index.vue/deleteItem shopsRepository.admin_delete (" +
              error +
              ")"
            );
          });

        init();

        store.dispatch("loadingIcon/hideIcon"); // ローディング非表示
      }
    };

    // 初期化処理(同期処理)
    const init = async () => {
      store.dispatch("loadingIcon/showIcon"); // ローディング表示

      state.agencies.splice(0);
      await agenciesRepository
        .admin_list()
        .then((response) => {
          if (response.data) {
            state.agencies.push({ value: null, text: "未選択" });
            Object.keys(response.data).forEach(function (key) {
              state.agencies.push({
                value: response.data[key].id,
                text: response.data[key].name,
              });
            });
          }
        })
        .catch((error) => {
          throw "ERROR:admin/shop/index.vue/init (" + error + ")";
        });

      state.users.splice(0);
      await usersRepository
        .admin_list()
        .then((response) => {
          if (response.data) {
            state.users.push({ value: null, text: "未選択", agency_id: null });
            Object.keys(response.data).forEach(function (key) {
              state.users.push({
                value: response.data[key].id,
                text: response.data[key].name,
                agency_id: response.data[key].agency_id,
              });
            });
          }
        })
        .catch((error) => {
          throw "ERROR:admin/shop/index.vue/init (" + error + ")";
        });

      state.desserts.splice(0);
      const repoMethod = state.resist_order
        ? shopsRepository.admin_list_createdat
        : shopsRepository.admin_list;
      await repoMethod(state.condition)
        .then((response) => {
          if (response.data) {
            Object.values(response.data).forEach((item) => {
              state.desserts.push(item);
            });
          }
        })
        .catch((error) => {
          throw "ERROR:admin/shop/index.vue/init (" + error + ")";
        });

      store.dispatch("loadingIcon/hideIcon"); // ローディング非表示
    };

    init();

    // 更新イベント
    watch(
      () => state.resist_order,
      () => {
        init();
      }
    );

    const updated = (user_data) => {
      init();
    };

    const changeCondition = () => {
      init();
    };

    // 代理店選択肢に連動したユーザー一覧（代理店未選択なら全件）
    const filteredUsers = computed(() => {
      if (state.condition.agency_id === null) {
        return state.users;
      }
      return state.users.filter(
        (u) => u.value === null || u.agency_id === state.condition.agency_id
      );
    });

    const onChangeAgency = () => {
      // 選択中ユーザーが代理店に属していなければクリア
      if (state.condition.user_id !== null) {
        const current = state.users.find(
          (u) => u.value === state.condition.user_id
        );
        if (
          !current ||
          (state.condition.agency_id !== null &&
            current.agency_id !== state.condition.agency_id)
        ) {
          state.condition.user_id = null;
        }
      }
      init();
    };

    const onChangeUser = () => {
      // ユーザーを選んだが代理店が未選択なら、ユーザーに紐づく代理店を自動セット
      if (
        state.condition.user_id !== null &&
        state.condition.agency_id === null
      ) {
        const current = state.users.find(
          (u) => u.value === state.condition.user_id
        );
        if (current && current.agency_id) {
          state.condition.agency_id = current.agency_id;
        }
      }
      init();
    };

    const updateShopReadAt = async (item) => {
      const params = {
        user_id: item.user_id,
        id: item.id,
      };
      await shopsRepository.admin_update_readat(params);
    };

    // 契約情報
    const contractItem = async (item) => {
      // // 遷移前にreadatを更新
      // await updateShopReadAt(item);
      // 契約画面に遷移
      await router.push({
        name: "admin-contract-edit",
        params: {
          shop_id: item.id,
        },
      });
    };

    // 媒体情報
    const shopSiteItem = async (item) => {
      // // 遷移前にreadatを更新
      // await updateShopReadAt(item);
      // 契約画面に遷移
      await router.push({
        name: "admin-setting-synchro",
        params: {
          shop_id: item.id,
          user_name: item.user_name,
          shop_name: item.name,
        },
      });
    };

    // 返却オブジェクト定義
    return {
      valid_contract_status,
      refAppBar,
      setting,
      ...toRefs(state),
      filteredUsers,
      editItem,
      deleteItem,
      init,
      updated,
      changeCondition,
      onChangeAgency,
      onChangeUser,
      contractItem,
      shopSiteItem,
    };
  },
});
</script>
<style scoped>
::v-deep .v-data-table table thead tr th,
::v-deep .v-data-table table tbody tr td {
  padding: 0 6px !important;
}
::v-deep .td_agency {
  min-width: 100px;
  width: 160px;
}
</style>
